import React, { useCallback } from 'react';
import '../../../styles/NewsTablePagination.css';
import { api } from '../../utils/api';

const NewsTablePagination = ({
    news,
    setNews,
    currentPage,
    setCurrentPage,
    totalCount,
    setTotalCount,
    rowsPerPage,
    setRowsPerPage,
    searchQuery,
    statusFilter,
    languageFilter,
    setIsLoading,
    setError,
    navigate
}) => {
    const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, totalCount);

    const fetchNewsData = useCallback(async (page, limit) => {
        setIsLoading(true);
        try {
            const params = {
                page,
                limit,
                ...(searchQuery && { search: searchQuery }),
                ...(statusFilter !== 'all' && { status: statusFilter }),
                ...(languageFilter !== 'all' && { language: languageFilter })
            };

            const response = await api.get('/admin/news', { params });
            if (response.data) {
                setNews(response.data.news || []);
                setTotalCount(response.data.totalNews || 0);
                setCurrentPage(page);
            }
        } catch (err) {
            console.error('Error in fetchNewsData:', err);
            if (err.response?.status === 401) {
                navigate('/login');
            } else {
                setError('Ошибка при загрузке новостей');
            }
        } finally {
            setIsLoading(false);
        }
    }, [searchQuery, statusFilter, languageFilter, setNews, setTotalCount, setCurrentPage, setIsLoading, setError, navigate]);

    const handlePageChange = async (page) => {
        if (page >= 1 && page <= totalPages) {
            await fetchNewsData(page, rowsPerPage);
        }
    };

    const handleRowsPerPageChange = async (event) => {
        const newLimit = parseInt(event.target.value, 10);
        setRowsPerPage(newLimit);
        await fetchNewsData(1, newLimit);
    };

    return (
        <div className="news-pagination">
            <div className="news-pagination-rows-per-page">
                <span className="news-pagination-rows-per-page-label">Строк на странице:</span>
                <select 
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="news-pagination-rows-per-page-select"
                >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <div className="news-pagination-controls">
                <button
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                    className={`news-pagination-button ${currentPage === 1 ? 'disabled' : ''}`}
                >
                    ««
                </button>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`news-pagination-button ${currentPage === 1 ? 'disabled' : ''}`}
                >
                    «
                </button>
                <span className="news-pagination-info">
                    {startIndex + 1}-{endIndex} из {totalCount}
                </span>
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`news-pagination-button ${currentPage === totalPages ? 'disabled' : ''}`}
                >
                    »
                </button>
                <button
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className={`news-pagination-button ${currentPage === totalPages ? 'disabled' : ''}`}
                >
                    »»
                </button>
            </div>
        </div>
    );
};

export default NewsTablePagination; 